import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from '../../../route/routes';
import { SpinnerService } from 'src/app/_components/spinner/spinner.service';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
  standalone: false
})
export class HomepageComponent implements OnInit {

  @Input() viewEventi!: boolean;
  @Input() viewReservation!: boolean;
  @Input() viewMdr!: boolean;

  constructor(private router: Router, private spinner: SpinnerService) { }

  event_url = ROUTES.EVENT.path;
  reservation_url = ROUTES.RESERVATION.path;
  mdr_url = ROUTES.MDR.path;

  ngOnInit(): void {
    this.spinner.hide();
  }

  goToUrl(url: string) {
    this.router.navigate([url]);
  }

}
